import { createSelector } from 'reselect'
import getTransferItems from '../items/getTransferItems'
import getLoyaltyProductType from 'loyalty/lib/getLoyaltyProductType'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'

export const getTransferItemsView = createSelector(
  (state: App.State) => getTransferItems(state),
  (state: App.State) => state.experience.experiences,
  (state: App.State) => getIsEnabledLuxPlusDiscountedExperiences(state),
  (state: App.State) => state.experience.experienceItemsValidation,
  (
    transferItems,
    experiences,
    isLuxPlusDiscountedExperiencesEnabled,
    itemsValidation,
  ): App.WithDataStatus<Array<App.Checkout.TransferItemView>> => {
    return {
      // make sure full experience data has been fetched for every transfer
      hasRequiredData: transferItems.every(transfer => !!experiences[transfer.experienceId]),
      data: transferItems.map((item): App.Checkout.TransferItemView => {
        const offer = experiences[item.experienceId]

        const itemValidation = itemsValidation[item.transactionKey]
        const isItemValid = !itemValidation || itemValidation.fetching || itemValidation.isValid

        return {
          title: item.transfer.title ?? '',
          loyalty: {
            productType: getLoyaltyProductType(offer),
          },
          item,
          totals: {
            mobileAppDiscount: {
              amount: item.transfer.option?.discounts?.app.amount ?? 0,
              percentage: item.transfer.option?.discounts?.app.percentage ?? 0,
            },
            price: item.hasLoyaltyBenefit ? 0 : (item.transfer.option?.price ?? 0),
            memberPrice: item.hasLoyaltyBenefit ? 0 : (isLuxPlusDiscountedExperiencesEnabled ? item.transfer.option?.memberPrice ?? 0 : 0),
            taxesAndFees: item.transfer.option?.taxesAndFees ?? 0,
            value: item.hasLoyaltyBenefit ? 0 : (item.transfer.option?.price ?? 0),
            memberValue: item.hasLoyaltyBenefit ? 0 : (isLuxPlusDiscountedExperiencesEnabled ? item.transfer.option?.memberPrice ?? 0 : 0),
            surcharge: 0,
            extraGuestSurcharge: 0,
          },
          isValid: !!isItemValid,
        }
      }),
    }
  },
)

export default getTransferItemsView
